// The account's recovery mobile (individual_user.alternate_mobile from /identity/v3/me).
// Module-level holder with listeners, like the Payment PIN flag: filled when the businesses
// load and updated by the recovery-mobile flow in Settings → Data Security Checkup.
let recoveryMobile = ''
const listeners = new Set<() => void>()

export const getRecoveryMobile = () => recoveryMobile

export const setRecoveryMobile = (mobile?: string | null) => {
  const next = mobile || ''
  if (next !== recoveryMobile) {
    recoveryMobile = next
    listeners.forEach((listener) => listener())
  }
}

export const subscribeRecoveryMobile = (listener: () => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
